export default __webpack_public_path__ + "static/media/royalfilogo.ab657c3b.svg";